export enum StartStatuses {
  NOT_SET = "NOT_SET",
  NOT_STARTED = "NOT_STARTED",
  ON_AIR = "ON_AIR",
  PAST = "PAST",
  // Same as past, but past 1+ day ago
  EXPIRED = "EXPIRED",
}
